define('home/views/ActivityCardPostView',[
    'home/mixins/withReasonOld',

    'home/views/common/ActivityCardPostBaseView',
    'home/views/ActivityFooterPostView',

    'home/templates/activityCardPost',
], function (
    withReason,

    ActivityCardPostBaseView,
    ActivityFooterPostView,

    activityCardPostTemplate
) {
    'use strict';

    var parent = ActivityCardPostBaseView;

    var ActivityCardPostView = parent.extend({
        template: activityCardPostTemplate,
        templateHelpers: function () {
            return {
                hasOverflowPosts: this.model.get('totalActivities') > this.model.activities.length,
                shouldCollapse: this.shouldCollapse(),
                discussionRoute: this.model.thread.getDiscussionRoute(),
            };
        },

        createFooterView: function () {
            return new ActivityFooterPostView({
                el: this.footerRegion.el,
                model: this.model,
            });
        },

        shouldCollapse: function () {
            return this.model.activities.length > 1;
        },
    });


    var proto = ActivityCardPostView.prototype;
    withReason.call(proto);

    return ActivityCardPostView;
});

